import { chatEn, chatEs, chatFr } from '@headshots/chat-app';
import { createI18n } from "vue-i18n";
import en from "./plugins/i18n/locales/en.json";
import es from "./plugins/i18n/locales/es.json";
import fr from "./plugins/i18n/locales/fr.json";

const messages = {
  es: {...es,...chatEs},
  en: {...en,...chatEn},
  fr: {...fr,...chatFr}
};

const i18n = createI18n({
  locale: "en",
  availableLocales: ['en', 'fr', 'es'],
  messages,
});

const { t, tm } = i18n.global;
export const $t = t;
export const $tm = tm;

export default i18n;